import { Component } from '@angular/core';
import { StatsService } from '../stats.service';
import { FormBuilder, FormControl } from '@angular/forms';
import { statsValidator } from '../stats-validation.directive';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.css']
})
export class StatsComponent {

  constructor(private formBuilder: FormBuilder, public statsService: StatsService) { this.resetForm() }

  ngOnChanges() {
    this.resetForm()
  }

  statForm = this.formBuilder.group({
    authorsHelped: [0],
    booksSold: [0],
    titlesPublished: [0],
    yearsExperience: [0],

  }, { validators: statsValidator })

  authorsHelpedControl = <FormControl>this.statForm.get('authorsHelped');
  booksSoldControl = <FormControl>this.statForm.get('booksSold');
  titlesPublishedControl = <FormControl>this.statForm.get('titlesPublished');
  yearsExperienceControl = <FormControl>this.statForm.get('yearsExperience');


  editStat() {
    this.resetForm()
    this.statsService.editingStats = true
    this.statsService.keepFocus = true
  }


  cancelUserEditing() {
    this.resetForm()
    this.statsService.editingStats = false
    this.statsService.keepFocus = false
  }

  resetForm() {
    this.authorsHelpedControl.setValue(this.statsService.authorsHelped)
    this.booksSoldControl.setValue(this.statsService.booksSold)
    this.titlesPublishedControl.setValue(this.statsService.titlesPublished)
    this.yearsExperienceControl.setValue(this.statsService.yearsExperience)
  }



  cancelClicked() {
    this.statsService.editStatsCancelled()
    this.statsService.editingStats = false
  }

  submitStatEdits() {
    const editedStat = this.createStatFromForm()
    if (this.authorsHelpedControl.value == this.statsService.authorsHelped && this.booksSoldControl.value == this.statsService.booksSold && this.titlesPublishedControl.value == this.statsService.titlesPublished && this.yearsExperienceControl.value == this.statsService.yearsExperience) {
      this.cancelUserEditing()
      alert("No changes made")
      return
    }
    this.statsService.updateStats(editedStat)
  }

  createStatFromForm(): Object {
    const authorsHelped = this.statForm.value.authorsHelped
    const booksSold = this.statForm.value.booksSold
    const titlesPublished = this.statForm.value.titlesPublished
    const yearsExperience = this.statForm.value.yearsExperience
    return ({authorsHelped: authorsHelped, booksSold: booksSold, titlesPublished: titlesPublished, yearsExperience: yearsExperience})
  }
}
